module.exports = __webpack_public_path__ + "img/filter.77ef2335.svg";